function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_81",
  "data-name": "Group 81",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_80",
  "data-name": "Group 80",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_65",
  "data-name": "Path 65",
  d: "M42.528,106.325l-1.184-4.737a.716.716,0,0,0,.567-.7v-.764A3.011,3.011,0,0,0,38.9,97.117H33.51V95.542a1.481,1.481,0,0,0-1.48-1.48H4.535a1.481,1.481,0,0,0-1.48,1.48v12.984a.716.716,0,0,0,1.432,0V95.542a.048.048,0,0,1,.048-.048H32.03a.048.048,0,0,1,.048.048v12.984a.716.716,0,0,0,1.432,0v-.812h8.45a2.343,2.343,0,0,1,2.225,1.623H41.958a.716.716,0,0,0-.716.716v1.527a2.246,2.246,0,0,0,2.244,2.244H44.3v3.15H42.425a4.533,4.533,0,0,0-8.571,0h-.345v-5.394a.716.716,0,0,0-1.432,0v5.394H17.222a4.533,4.533,0,0,0-8.571,0H4.535a.048.048,0,0,1-.048-.048v-1.575h3.1a.716.716,0,1,0,0-1.432H.716a.716.716,0,1,0,0,1.432H3.055v1.575a1.481,1.481,0,0,0,1.48,1.48H8.4c0,.016,0,.032,0,.048a4.535,4.535,0,0,0,9.069,0c0-.016,0-.032,0-.048H33.606c0,.016,0,.032,0,.048a4.535,4.535,0,0,0,9.069,0c0-.016,0-.032,0-.048h2.34a.716.716,0,0,0,.716-.716v-7.637A3.777,3.777,0,0,0,42.528,106.325ZM33.51,98.549H38.9a1.577,1.577,0,0,1,1.575,1.575v.048H33.51Zm0,7.733V101.6h6.362l1.169,4.678ZM12.936,121.557a3.1,3.1,0,1,1,3.1-3.1A3.106,3.106,0,0,1,12.936,121.557Zm25.2,0a3.1,3.1,0,1,1,3.1-3.1A3.106,3.106,0,0,1,38.14,121.557Zm6.158-9.165h-.812a.812.812,0,0,1-.812-.812v-.812H44.3v1.623Z",
  transform: "translate(0 -94.062)",
  fill: "#0d47a1"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_83",
  "data-name": "Group 83",
  transform: "translate(11.456 22.913)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_82",
  "data-name": "Group 82",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_66",
  "data-name": "Path 66",
  d: "M129.747,350.6a1.48,1.48,0,1,0,1.48,1.48A1.481,1.481,0,0,0,129.747,350.6Z",
  transform: "translate(-128.267 -350.597)",
  fill: "#0d47a1"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Group_85",
  "data-name": "Group 85",
  transform: "translate(36.66 22.913)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_84",
  "data-name": "Group 84",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_67",
  "data-name": "Path 67",
  d: "M411.935,350.6a1.48,1.48,0,1,0,1.48,1.48A1.481,1.481,0,0,0,411.935,350.6Z",
  transform: "translate(-410.455 -350.597)",
  fill: "#0d47a1"
})));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Group_87",
  "data-name": "Group 87",
  transform: "translate(18.33 19.858)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_86",
  "data-name": "Group 86",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_68",
  "data-name": "Path 68",
  d: "M216.636,316.393H205.943a.716.716,0,1,0,0,1.432h10.692a.716.716,0,0,0,0-1.432Z",
  transform: "translate(-205.227 -316.393)",
  fill: "#0d47a1"
})));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "Group_89",
  "data-name": "Group 89",
  transform: "translate(1.527 16.803)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_88",
  "data-name": "Group 88"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_69",
  "data-name": "Path 69",
  d: "M26.983,282.188H17.818a.716.716,0,0,0,0,1.432h9.165a.716.716,0,0,0,0-1.432Z",
  transform: "translate(-17.102 -282.188)",
  fill: "#0d47a1"
})));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  id: "Group_91",
  "data-name": "Group 91",
  transform: "translate(12.984 6.874)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_90",
  "data-name": "Group 90"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_70",
  "data-name": "Path 70",
  d: "M157.285,171.232a.716.716,0,0,0-1.013,0L149.9,177.6l-3.312-3.312a.716.716,0,0,0-1.013,1.013l3.819,3.819a.716.716,0,0,0,1.012,0l6.874-6.874A.716.716,0,0,0,157.285,171.232Z",
  transform: "translate(-145.37 -171.023)",
  fill: "#0d47a1"
})));

var SvgFiFreeDelivery48 = function SvgFiFreeDelivery48(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "shipped",
    width: 45.729,
    height: 28.927,
    viewBox: "0 0 45.729 28.927",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFiFreeDelivery48, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fi-free-delivery-48.810d5355.svg";
export { ForwardRef as ReactComponent };